var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.492 4.03l-6.03 6.716L3.875 4.03 6.461.448h3.016l3.015 3.582z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.815 3.735L9.8.153A.433.433 0 009.477 0H3.445a.417.417 0 00-.323.153L.107 3.735a.458.458 0 00.009.6l6.031 6.717a.432.432 0 00.315.142.417.417 0 00.315-.142l6.031-6.716a.457.457 0 00.007-.6zm-1.272-.153H9.26L7.323.896H9.28l2.262 2.686zm-7.959.896l1.623 4.216L1.42 4.478h2.163zm4.825 0L6.461 9.54 4.513 4.478h3.896zm-3.671-.896L6.46 1.194l1.723 2.388H4.738zm4.6.896H11.5L7.715 8.694l1.623-4.216zM3.64.896h1.958L3.661 3.582H1.379L3.641.896z"
  })));
}
export default SvgDiamond;